// extracted by css-extract-rspack-plugin
export default {"Text":"column-settings-saved-message-module__Text__Trbse"};